import lo from 'lodash'

export const setCredentialsLocal = (value) => {
  localStorage.setItem('@Credential', JSON.stringify(value))
}

export const getCredentialsLocal = (cb) => {
  const value = localStorage.getItem('@Credential')
  cb(JSON.parse(value))
}

export const removeCredentialsLocal = () => {
  localStorage.removeItem('@Credential')
}

export const isCredentialsExists = () => {
  const value = localStorage.getItem('@Credential')
  if (!lo.isEmpty(value)) {
    return true
  } else {
    return false
  }
}
